<template>
  <v-container fluid>
    <v-row>
    <v-col cols="12" sm="6" md="6">
      <v-combobox
        v-model="item.type"
        :items="actiontypeSelectItems"
        :no-data-text="$t('global.no_result')"
        :placeholder="$t('global.no_select')"
        clearable
        :label="$t('ticket.actiontype')"
        item-text="name"
        item-value="@id"
      />
    </v-col>
    </v-row>
    <v-row>
      <h3>{{ $t('global.number') }} {{ $t('ticket.ticket') }} </h3>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field 
          v-model="item.ticket"
          :placeholder="$t('global.number')"
          clearable
          type="number"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="userSelectItems"
          v-model="item.ticket_sub_assigned"
          :items="userSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('administration.user.user')"
          item-text="login"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <h3>{{ $t('global.createdat') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.date_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.date_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import InputDate from '../InputDate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
export default {
  name: 'TicketactionFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  components: {
    InputDate,
  },
  data() {
    return {};
  },
  mounted() {
    this.actiontypeGetSelectItems();
    this.userGetSelectItems();
  },

  computed: {
    ...mapFields('actiontype', {
      actiontypeSelectItems: 'selectItems',
    }),
    ...mapFields('user', {
      userSelectItems: 'selectItems',
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      actiontypeGetSelectItems: 'actiontype/fetchSelectItems',
      userGetSelectItems: 'user/fetchSelectItems',
    }),
  }
};
</script>